import store from '@/store'
import { appID as constAppID } from '@/const/underwriting'

export const motorGeneral = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorGeneral is 1
    if (quoteLifeCycle < 1 || appID !== constAppID.MOTOR) {
      // For general, can only go back to sales oppo
      next({ name: 'quotation' })
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const motorDriver = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorDriver is 2
    if (appID !== constAppID.MOTOR) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 2) {
      if (quoteLifeCycle === 1) {
        next({ name: 'motorQuote' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const motorVehicle = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorVehicle is 3
    if (appID !== constAppID.MOTOR) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 3) {
      if (quoteLifeCycle === 1) {
        next({ name: 'motorQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'motorQuoteDriver' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const motorStats = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorStats is 4
    if (appID !== constAppID.MOTOR) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 4) {
      if (quoteLifeCycle === 1) {
        next({ name: 'motorQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'motorQuoteDriver' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'motorQuoteVehicle' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const motorPremium = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NQ') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorPremium is 5
    if (appID !== constAppID.MOTOR) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 5) {
      if (quoteLifeCycle === 1) {
        next({ name: 'motorQuote' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'motorQuoteDriver' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'motorQuoteVehicle' })
      } else if (quoteLifeCycle === 4) {
        next({ name: 'motorQuoteStatistics' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}
